import { IsiPersonReportDetail, ISICountryWisePerson } from './../isi-report-detail/isi-report-detail.model';
import { ConstantsService } from './../../services/constants-service';
import { Component, OnInit, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'country-wise-person',
  templateUrl: './country-wise-person.component.html',
  styleUrls: ['./country-wise-person.component.css']
})
export class CountryWisePersonComponent {
  personLogo = ConstantsService.DEFAULT_PERSON_MALE_LOGO;
  @Input()
  reportData: ISICountryWisePerson;
  @Input()
  listName: string;

  constructor() { }

  toggleList(reportData: ISICountryWisePerson) {
    this.reportData.open = !reportData.open;
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/country-wise-person/country-wise-person.component.ts